import { BROADCAST_SET_SCREEN_ACTIVE } from 'actions/Types';

const isScreenShareActive = (state = false, { type, payload }) => {
  if (type === BROADCAST_SET_SCREEN_ACTIVE) {
    return payload;
  }

  return state;
};

export default isScreenShareActive;
